module.exports = __webpack_public_path__ + "img/KSC05687.6d706e37.jpg";